import React from 'react';
import { useTable, useFilters, useGlobalFilter, useSortBy } from 'react-table';
import { matchSorter } from 'match-sorter';
import { Table } from 'react-bootstrap';
import Multiselect from './Clima/Multiselect';
import ReactSelect from 'react-select';

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  return (
    <div className="mt-3">
      <input
        className="form-control form-control-sm rounded-pill"
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}
        placeholder={`Buscar ${count} registros...`}
      />
    </div>
  );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] });
}

fuzzyTextFilterFn.autoRemove = (val) => !val;

function CustomTable({ columns, data, updateData, ...props }) {
  const [editedCells, setEditedCells] = React.useState({});

  const handleCellEdit = (rowIndex, columnId, value) => {
    const key = `${rowIndex}-${columnId}`;
    setEditedCells({ ...editedCells, [key]: value });
  };

  const filterTypes = React.useMemo(
    () => ({
      fuzzyText: fuzzyTextFilterFn,
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );

  const defaultColumn = React.useMemo(
    () => ({
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const {
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      filterTypes,
    },
    useFilters,
    useGlobalFilter,
    useSortBy
  );

  return (
    <div>
      <Table striped responsive>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  className="text-muted font-weight-normal"
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  <span className="ml-2">{column.render('Header')}</span>
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <i className="material-icons">arrow_drop_down</i>
                      ) : (
                        <i className="material-icons">arrow_drop_up</i>
                      )
                    ) : column.canFilter ? (
                      <i className="fas fa-sort ml-2"></i>
                    ) : null}
                  </span>
                  <div className="mt-4">
                    {/* Modificado para mostrar un menú desplegable si la columna tiene la propiedad 'select' */}
                    {column.canFilter && !column.select ? column.render('Filter') : null}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      contentEditable={cell.column.edit} // Permitir edición si la columna tiene la propiedad 'edit'
                      onBlur={(e) =>
                        handleCellEdit(i, cell.column.id, e.target.innerHTML)
                      }
                    >
                      {/* Modificado para mostrar un menú desplegable si la columna tiene la propiedad 'select' */}
                      {cell.column.select ? (
                        
                         <ReactSelect
                          options={cell.column.options}
                          value={cell.value}
                          onChange={(selectedOption) => handleCellEdit(i, cell.column.id, selectedOption)}
                          isMulti
                          isSearchable
                          defaultValue={cell.column.options[1]}
                          placeholder="Seleccionar..."
                          menuPlacement='top'
                          className="basic-multi-select"
                          classNamePrefix="select"
                         />
                      ) : (
                        // Si no tiene 'select', mostrar el valor de la celda
                        cell.render('Cell')
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

function filterGreaterThan(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}

filterGreaterThan.autoRemove = (val) => typeof val !== 'number';

export default CustomTable;
